import { createSlice } from '@reduxjs/toolkit'

export const stickySlice = createSlice({
    name: 'sticky',
    initialState:{
        isSticky: false
    },
    reducers: {
        setSticky: state => {
          state.isSticky = true;
        },
        unsetSticky: state => {
          state.isSticky = false;
        }
      }
    });

    export const { setSticky, unsetSticky } = stickySlice.actions;
    export default stickySlice.reducer;